import React, { useEffect, useState } from "react";
import { Card, Offcanvas } from "react-bootstrap";
import SiteSubjectDataEntryGraph from "./Graph/SiteSubjectDataEntryGraph";
import SiteSubjectQueryBarGraph from "./Graph/SiteSubjectQueryBarGraph";
import SiteSubjectSDVGraph from "./Graph/SiteSubjectSDVGraph";
import { useParams } from "react-router";
import { studySiteDataEntryServices } from "../../../../../APIServices/studySiteDataEntryServices";
import SiteSubjectNotificationBarGraph from "./Graph/SiteSubjectNotificationBarGraph";

const ViewSiteSubjectGraph = ({ Show, Hide, Title, siteId, subjectId }) => {
  const [subjectQuery, setSubjectQuery] = useState([]);
  const [subjectNotification, setSubjectNotification] = useState([]);
  const [subjectSDV, setSubjectSDV] = useState(0);
  const [subjectDataEntry, setSubjectDataEntry] = useState(0);

  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  let { studyId } = useParams();
  const getStudyFormBySiteSubjectTotalQuery = async () => {
    setSubjectQuery([]);
    let userData = {}
    userData.siteId = siteId
    userData.studyId = studyId
    userData.subjectId = subjectId
    userData.mode = StudyMode
    let data = await studySiteDataEntryServices.getStudyFormBySiteSubjectTotalQuery(userData)
    setSubjectQuery(data?.data);
  };

  const getStudyFormBySiteSubjectTotalNotification = async () => {
    setSubjectNotification([]);
    let userData = {}
    userData.siteId = siteId
    userData.subjectId = subjectId
    userData.studyId = studyId
    userData.mode = StudyMode
    let data = await studySiteDataEntryServices.getStudyFormBySiteSubjectTotalNotification(userData)
    setSubjectNotification(data?.data);
  };

  const getStudyBySiteSubjectFormSDVHistory = async () => {
    setSubjectSDV([]);
    let userData = {}
    userData.siteId = siteId
    userData.subjectId = subjectId
    userData.studyId = studyId
    userData.mode = StudyMode
    let data = await studySiteDataEntryServices.getStudyBySiteSubjectFormSDVHistory(userData)
    setSubjectSDV(data?.data);
  };

  const getStudyBySiteSubjectFormDataEntry = async () => {
    setSubjectDataEntry([]);
    let userData = {}
    userData.siteId = siteId
    userData.subjectId = subjectId
    userData.studyId = studyId
    userData.mode = StudyMode
    let data = await studySiteDataEntryServices.getStudyBySiteSubjectFormDataEntry(userData)
    setSubjectDataEntry(data?.data);
  };

  useEffect(() => {
    if (siteId !== "no" && subjectId) {
      getStudyFormBySiteSubjectTotalQuery()
      getStudyFormBySiteSubjectTotalNotification()
      getStudyBySiteSubjectFormSDVHistory()
      getStudyBySiteSubjectFormDataEntry()
    }
  }, [siteId, subjectId]);
  return (
    <Offcanvas show={Show} onHide={Hide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{Title}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Card className="br3 bg-light shadow-sm border mb-3">
          <SiteSubjectQueryBarGraph subjectQuery={subjectQuery} />
        </Card>
        <Card className="br3 bg-light shadow-sm border mb-3">
          <SiteSubjectNotificationBarGraph subjectNotification={subjectNotification} />
        </Card>
        <Card className="br3 bg-light shadow-sm border mb-3">
          <SiteSubjectSDVGraph subjectSDV={subjectSDV} />
        </Card>
        <Card className="br3 bg-light shadow-sm border">
          <SiteSubjectDataEntryGraph subjectDataEntry={subjectDataEntry} />
        </Card>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default ViewSiteSubjectGraph;
